import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=a3162362&scoped=true&"
import script from "./LoginBox.vue?vue&type=script&lang=ts&"
export * from "./LoginBox.vue?vue&type=script&lang=ts&"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=a3162362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3162362",
  null
  
)

component.options.__file = "LoginBox.vue"
export default component.exports